import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'home',
    loadComponent: () => import('./pages/home/home.page').then((m) => m.HomePage),
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.page').then( m => m.LoginPage)
  },
  
{
    path: 'legals',
    loadComponent: () => import('./pages/legals/legals.page').then( m => m.LegalsPage)
  },
  
  {
    path: 'sard-promotion',
    loadComponent: () => import('./pages/sard-promotion/sard-promotion.page').then( m => m.SardPromotionPage)
  },
  {
    path: 'disclaimer',
    loadComponent: () => import('./pages/disclaimer/disclaimer.page').then( m => m.DisclaimerPage)
  },
  {
    path: 'mainmenu',
    loadComponent: () => import('./pages/mainmenu/mainmenu.page').then( m => m.MainmenuPage)
  },
  {
    path: 'manufacturers',
    loadComponent: () => import('./pages/manufacturers/manufacturers.page').then( m => m.ManufacturersPage)
  },
  {
    path: 'manufacturers-devices/:id',
    loadComponent: () => import('./pages/manufacturers-devices/manufacturers-devices.page').then( m => m.ManufacturersDevicesPage)
  },

  {
  path: 'manufacturers-devices/:id',
  loadComponent: () =>
    import('./pages/manufacturers-devices/manufacturers-devices.page').then(
      (m) => m.ManufacturersDevicesPage
    ),
},
  {
    path: 'device-info/:id',
    loadComponent: () => import('./pages/device-info/device-info.page').then( m => m.DeviceInfoPage)
  },
  {
    path: 'device-legals/:id',
    loadComponent: () => import('./pages/device-legals/device-legals.page').then( m => m.DeviceLegalsPage)
  },
  {
    path: 'devices',
    loadComponent: () => import('./pages/devices/devices.page').then( m => m.DevicesPage)
  },
  {
    path: 'search',
    loadComponent: () => import('./pages/search/search.page').then( m => m.SearchPage)
  },
  {
    path: 'search-results',
    loadComponent: () => import('./pages/search-results/search-results.page').then( m => m.SearchResultsPage)
  },

];
